import React from 'react';

import { flagStyles } from '../settings';

const SvgBB = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-384px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBB;
